import { GroupPickemLeaderboard } from "components/Pickem/Leaderboard/GroupPickemLeaderboard";
import { GrowColumn } from "pages/styles";

interface Props {
  memberIds: string[];
}

export const GroupLeaderboard = ({ memberIds }: Props) => {
  return (
    <GrowColumn>
      <GroupPickemLeaderboard memberUids={memberIds} />
    </GrowColumn>
  );
};
